import useGreeksWebsocketDataStore from '../../Store/GreeksWebsocketDataStore';

export const adaptiveLevelsGetter = function (PineJS) {
  return Promise.resolve([
    {
      name: 'SPX Daily Adaptive Levels',
      metainfo: {
        metainfoVersion: 53,
        id: "SPX Daily Adaptive Levels@tv-basicstudies-1",
        description: "SPX Daily Adaptive Levels",
        shortDescription: "SPX Daily Adaptive Levels",
        format: { type: "price" },
        linkedToSeries: true,
        is_price_study: true,
        plots: [
          {
            id: "ddh",
            type: "line"
          },
          {
            id: "ddl",
            type: "line"
          }
        ],
        defaults: {
          styles: {
            ddh: {
              linestyle: 0,
              linewidth: 1,
              transparency: 0,
              color: "#ffffff",
            },
            ddl: {
              linestyle: 0,
              linewidth: 1,
              transparency: 0,
              color: "#ffffff",
            }
          },
        },
        styles: {
          ddh: { title: "Adaptive Daily High (DDH)" },
          ddl: { title: "Adaptive Daily Low (DDL)" }
        },
        inputs: [],
      },
      constructor: function () {
        this._debugMode = true;
        this._lastIndex = null;
        this._data = [];

        this.init = function (ctx) {
          this._context = ctx;
        };

        this.main = function (ctx, inputCallback) {
          try {
          const { adaptiveDynamicLevels } = useGreeksWebsocketDataStore.getState();
          const spxLevels = adaptiveDynamicLevels.spx;

            if (!spxLevels?.length) {
              if (this._debugMode) {
                console.log('[dynamicLevelsGetter] No dynamic levels data');
              }
              return [NaN, NaN];
            }

            // Get the current bar's time
            const currentTime = ctx.symbol.time;

            // Find the levels that correspond to this time
            const timeBasedLevels = spxLevels.filter(level => {
              return level.timestamp * 1000 <= currentTime;
            });

            // Get the most recent DDH and DDL levels for this time
            const ddhLevel = timeBasedLevels
              .filter(level => level.level_type === 'DDH')
              .sort((a, b) => b.timestamp - a.timestamp)[0]?.strike_price;

            const ddlLevel = timeBasedLevels
              .filter(level => level.level_type === 'DDL')
              .sort((a, b) => b.timestamp - a.timestamp)[0]?.strike_price;

            // if (this._debugMode) {
            //   console.log('[dynamicLevelsGetter] Time-based Levels:', {
            //     time: new Date(currentTime),
            //     ddh: ddhLevel,
            //     ddl: ddlLevel,
            //     availableLevelsCount: timeBasedLevels.length
            //   });
            // }

            // Store the data point
            if (ctx.new_bar) {
              this._data.push({
                time: currentTime,
                ddh: ddhLevel,
                ddl: ddlLevel
              });
            }

            return [ddhLevel, ddlLevel];
          } catch (err) {
            console.error('[dynamicLevelsGetter] Error in main:', err);
            return [NaN, NaN];
          }
        };

        this.destroy = function() {
          this._data = [];
        };
      },
    },
  ]);
};
